import * as React from "react";

function SvgConversation24Px(props) {
    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fill="#ffffff"
                d="M20.666 2h-8.053c-1.284 0-2.305 1.014-2.305 2.267v.298H3.743C2.225 4.565 1 5.758 1 7.25v7.367c0 1.491 1.225 2.684 2.743 2.684h.817v.03c.058.239.116.686-.117 1.253-.38.925-1.371 1.79-1.371 1.79-.117.09-.146.238-.088.387.058.15.175.239.321.239.088 0 2.422-.03 4.143-1.312 1.313-1.014 2.014-1.969 2.247-2.327h3.735c1.517 0 2.742-1.193 2.742-2.684V7.309c0-1.491-1.225-2.684-2.742-2.684h-2.48v-.298c0-.895.758-1.641 1.721-1.641h8.053c.934 0 1.722.746 1.722 1.64v6.145c0 .895-.759 1.64-1.722 1.64h-.875a.305.305 0 00-.263.15c-.029.03-.408.775 0 1.76.146.327.35.656.613.984l.087.09-.116-.03c-.613-.12-1.488-.358-2.16-.895-.379-.299-.7-.597-1.02-.925l-.059-.06v.865c.233.209.467.388.7.597 1.43 1.103 3.385 1.103 3.472 1.103.117 0 .234-.09.292-.208.059-.12 0-.269-.087-.358-.03-.03-.817-.716-1.138-1.492a1.897 1.897 0 01-.117-1.014v-.03h.642c1.284 0 2.305-1.014 2.305-2.266V4.237C23 3.014 21.95 2 20.666 2zM13.4 5.251c1.139 0 2.072.895 2.072 1.999v7.367c0 1.104-.933 1.998-2.072 1.998H9.49a.32.32 0 00-.291.18c-.03.059-.671 1.163-2.188 2.326-.876.656-1.955.954-2.714 1.074l-.117.03.088-.09c.35-.418.642-.865.788-1.253.496-1.163.029-2.028.029-2.088a.32.32 0 00-.292-.179H3.772c-1.138 0-2.072-.894-2.072-1.998V7.25c0-1.104.934-1.999 2.072-1.999H13.4z"
                stroke="#ffffff"
                strokeWidth={0.5}
            />
        </svg>
    );
}

export default SvgConversation24Px;
